import {
  Component,
  OnInit,
  ViewEncapsulation,
  Inject,
  ViewChild,
  ElementRef
} from "@angular/core";
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
  PageEvent
} from "@angular/material";
import { Zone, futureZone } from "../../shared/interface/zone";
import { Device, kpiGroups } from "../../shared/interface/device";
import { ZoneService } from "../../shared/services/zone/zone.service";
import { SiteService } from "../../shared/services/site/site.service";
import { Observable } from "rxjs/Observable";
import { startWith } from "rxjs/operators/startWith";
import { map } from "rxjs/operators/map";
import { Site } from "../../shared/interface/site";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors
} from "@angular/forms";
import { KpiGroups } from "../../shared/interface/kpi-groups";
import { FormArray } from "@angular/forms/src/model";
import { CommonService } from "../../shared/services/index";
import "rxjs/add/operator/debounceTime";
import { Subject } from "rxjs/Subject";
import { environment } from "../../../environments/environment";
import { grep } from "jquery";

@Component({
  selector: "app-zones",
  templateUrl: "./zones.component.html",
  styleUrls: ["./zones.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class ZonesComponent implements OnInit {
  dataSource: Zone[];
  pageLength: number;
  pageSize: number = 10;
  pageSizeOptions = [10, 25, 50];
  pageEvent: any;
  filter = {
    page: 1,
    limit: 10,
    where: {}
  };
  private subject: Subject<string> = new Subject();
  searchLoading = 0;
  zoneButtonDisabled = true;
  dataSite: Site[] = [];

  constructor(
    public dialog: MatDialog,
    private zoneService: ZoneService,
    private siteService: SiteService, 
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.getSiteCount();
    this.getSiteList();
    this.setList(this.filter,1);    
    this.zoneService.getAction().subscribe(data => {
      if (
        ["create", "update", "siteCreate", "siteDelete"].includes(data.action)
      ) {
        this.setList(this.filter);
        this.setList("", 1);
      }
      if (["siteDelete", "updateSiteCount"].includes(data.action)) {
        this.getSiteCount();
      }
    });
    this.subject.debounceTime(200).subscribe(filterTerm => {
      this.filter.page = 1;
      this.filter.limit = 10;
      this.filter.where = {
        zoneName: filterTerm
      };
      this.setList(this.filter);
      this.setList("", 1);
    });
  }

  getSiteCount() {
    this.zoneService.siteList().subscribe(res => {
      this.zoneButtonDisabled = res.length >= 1 ? false : true;
    });
  }

  filterData(filterTerm) {
    this.subject.next(filterTerm);
    this.searchLoading = 1;
  }

  paginateData(pageEvent) {
    this.filter.page = pageEvent.pageIndex + 1;
    this.filter.limit = pageEvent.pageSize;
    this.setList(this.filter);
  }

  setList(filter = {}, loadCount = 0) {   
    let filterString = this.commonService.buildFilter(filter);   
    if (loadCount == 1) {
      this.zoneService.count(filterString).subscribe(
        res => {          
          this.pageLength =(res.count ? res.count : 0);
          this.searchLoading = 0;
        },
        err => { }
      );      
    }         
    this.zoneService.list(filterString).subscribe(
      res => {
        this.dataSource = res;
        this.searchLoading = 0;
      },
      err => { }
    );
  }

  openZoneDialog = (data = {}) => {
    this.dialog.open(ZoneDialog, {
      data: data,
      height: "auto",
      width: "600px",
      panelClass: "full-modal"
    });
  };

  openZoneMapDialog = (data = {}) => {
    this.dialog.open(ZoneMapDialog, {
      data: data,
      height: "auto",
      width: "800px",
      panelClass: "full-modal"
    });
  };

  //Delete Zone
  delete(_id: string) {
    if (confirm("Are you sure you want to remove this Zone.") == false) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);
    this.zoneService.delete(_id).subscribe(
      r => {
        this.pageLength -= 1;
      },
      e => {
        this.dataSource = temp;
      }
    );
  }

  getSiteList() {
    this.siteService.list("fields=siteName,isActive,address").subscribe(r => {
      this.dataSite = r;      
    });
  }

  filterDataBySite(siteId) {
    this.filter.where["siteId"] = siteId;
    if (!this.filter.where["siteId"]) {
      this.filter.where["siteId"] = "";
    }
    this.filter.page = 1;
    this.filter.limit = 10;    
    this.setList(this.filter, 1);
  }

}

@Component({
  selector: "zone-dialog",
  templateUrl: "zone.dialog.html"
})
export class ZoneDialog {
  zoneForm: FormGroup;
  dataSite$: Observable<Site[]>;
  isSubmitted: number = 0;
  today = new Date();
  minDate = new Date();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private zoneService: ZoneService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ZoneDialog>,
    public commonService: CommonService
  ) {
    this.dataSite$ = this.zoneService.siteList();
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.minDate.setHours(1, 0, 0, 0);
    this.today.setHours(1, 0, 0, 0);
    data = this.parseData(data);
    this.createForm(data);
  }
  get ScheduledArr() {
    return this.zoneForm.get('Scheduled') as FormArray;
  }
  createForm(data: any) {
    this.zoneForm = this.fb.group({
      _id: [data._id],
      zoneName: [data.zoneName, Validators.required],
      siteId: [data.siteId, Validators.required],
      replaceMode: '0',
      replaceDateTime: '',
      isActive: data.isActive,
      Scheduled: this.fb.array([])
    });
    if (data.Scheduled.length > 0)
      this.setFutureZoneNameFilter(data.Scheduled);
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  blockInput($event) {
    $event.preventDefault();
  }

  dbTimeToPickerTime(time) {
    let dateToday = new Date();
    let timeArray = time.split(':');
    let datt = new Date(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate(), timeArray[0], timeArray[1], timeArray[2]);
    let convertedDate = this.commonService.getDateConverted(datt, "YYYY-MM-DD HH:mm:ss");
    return new Date(convertedDate);
  }

  pickerTimeToDBTime(pDate) {
    let dtf = pDate;
    let convertedDate = new Date(this.commonService.getDateConverted(dtf, "YYYY-MM-DD HH:mm:ss"));
    let sdf2 = this.addZero(convertedDate.getHours()) + ':' + this.addZero(convertedDate.getMinutes()) + ':' + this.addZero(convertedDate.getSeconds());
    return sdf2;

  }
  //parse data while create and update
  parseData(data: any) {
    if (data.zoneName) {
      return data;
    }

    return {
      _id: "",
      zoneName: "",
      siteId: "",
      replaceMode: '0',
      replaceDateTime: '',
      isActive: 1,
      Scheduled: this.fb.array([])
    };
  }

  onSubmit(form: any) {
    if (!this.zoneForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    //Create zone
    if (form._id == "") {
      form["future"] = false;
      this.zoneService.create(form).subscribe(
        res => {
          this.dialogRef.close();
          this.zoneService.sendAction("create", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      if (confirm(
        "Do you want to override the current name?") == false) {
        this.isSubmitted = 0;
        return false;
      }
      //Update zone
      form.zoneId = form._id;
      form.isActive = form.isActive ? 1 : 0;
      form["future"] = this.commonService.inFuture(form.replaceDateTime);
      if (form.replaceDateTime)
        form.replaceDateTime = form.replaceDateTime;
      this.zoneService.update(form).subscribe(
        res => {
          this.dialogRef.close();
          this.zoneService.sendAction("update", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }

  gridDate = (value: any) => {
    let d = new Date(value);
    let u =
      d.getFullYear() +
      "-" +
      this.addZero(d.getMonth() + 1) +
      "-" +
      this.addZero(d.getDate()) +
      "T" +
      this.addZero(d.getHours()) +
      ":" +
      this.addZero(d.getMinutes())

    return u;
  }

  edit = (i: number) => {
    for (let j = 0; j < this.ScheduledArr.length; j++) {
      let editItem = this.ScheduledArr.at(j) as FormArray;
      editItem.controls["edit"].value = (i === j ? true : false);
      this.ScheduledArr.at(j).patchValue(editItem);
    }
  }

  cancel = (id: string) => {
    this.zoneService.scheduledZoneList(id).subscribe(
      res => {
        this.setFutureZoneNameFilter(res as futureZone[]);
      })
  }

  delete = (id: string, i: number) => {
    if (confirm("Are you sure you want to remove this?") == false) {
      return false;
    }
    this.zoneService.deleteFutureZone(id).subscribe(
      r => {
        this.ScheduledArr.removeAt(i);
        this.zoneService.sendAction("update", "");
      },
      e => { }
    );
  }

  update = (data: {}, i: number) => {
    let date = data["scheduledDate"];
    data["replaceDateTime"] = date;
    data["future"] = this.commonService.inFuture(data["scheduledDate"]);
    if (data["future"]) {
      this.zoneService.updateFutureZone(data).subscribe(
        res => {
          this.zoneService.scheduledZoneList(data["zoneId"]).subscribe(
            res => {
              this.setFutureZoneNameFilter(res as futureZone[]);
            });
          this.zoneService.sendAction("update", "");
        },
        err => {
        }
      );
    }
    else {
      this.zoneService.scheduledZoneList(data["zoneId"]).subscribe(
        res => {
          this.setFutureZoneNameFilter(res as futureZone[]);
        })
      let editItem = this.ScheduledArr.at(i) as FormArray;
      editItem.controls["edit"].value = true;
      this.ScheduledArr.at(i).patchValue(editItem);
      this.commonService.openSnackBar("Only future dates are allowed", "");
    }
  }

  setFutureZoneNameFilter(futureZone: futureZone[]) {
    const futureZoneFormGroups = futureZone.map((fields, i) => {
      const gorup = this.fb.group({
        _id: fields._id,
        zoneName: [fields.zoneName, Validators.required],
        siteId: fields.siteId,
        zoneId: fields.zoneId,
        scheduledDate: fields.scheduledDate,
        edit: false
      })
      return gorup;
    });
    const FilterFormArray = this.fb.array(futureZoneFormGroups);
    this.zoneForm.setControl("Scheduled", FilterFormArray);
  }

}

@Component({
  selector: "zone-map-dialog",
  templateUrl: "zone-map.dialog.html"
})
export class ZoneMapDialog {
  zoneMapForm: FormGroup;
  deviceAutoComplete: FormControl = new FormControl();
  deviceList: Device[] = [];
  kpiGroups = [];
  isSubmitted: number = 0;
  footFallKpiGroupId = environment.footFallKpiGroupId;
  @ViewChild("siteId")
  siteId: ElementRef;
  IsValid = false;
  selectedDeviceId: string = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public zoneService: ZoneService,
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<ZoneMapDialog>
  ) {
    this.footFallKpiGroupId = environment.footFallKpiGroupId;

    this.createForm(data);
    // console.log(data.siteId);
    this.zoneMapForm.controls["deviceId"].valueChanges
      .debounceTime(400)
      .subscribe(deviceName => {
        let siteId = this.siteId.nativeElement.value;
        // this.kpiGroups = [];
        this.zoneService.deviceList(deviceName, siteId, 1).subscribe(r => {
          if (r) {
            this.deviceList = r;
          }
        });
      });
  }

  createForm(data: any) {
    this.zoneMapForm = this.fb.group({
      zoneId: data._id,
      deviceId: ["", Validators.required],
      kpiGroups: this.fb.array([])
    });
  }

  setKpiGroups() {
    let kgs: any = [];
    this.kpiGroups.forEach(kg => {
      kg = {
        kpiGroupId: kg.kpiGroupId,
        kpiGroupName: kg.kpiGroupName,
        selected: false,
        kpiFactorBy: ["1", Validators.pattern("^[0-9]{1,2}(\.[0-9]{1,2})?$")],
        operation: "*",
        elements: ["", Validators.pattern("^([0-9]*[,]?[^,]?[0-9])+$")],
        elementAdult: [
          "",
          [
            Validators.pattern("^([0-9]*[,]?[^,]?[0-9])+$"),
            this.getFootFallCoOrdinates
          ]
        ],
        elementChild: [
          "",
          [
            Validators.pattern("^([0-9]*[,]?[^,]?[0-9])+$"),
            this.getFootFallCoOrdinates
          ]
        ],
        elementStaff: [
          "",
          [
            Validators.pattern("^([0-9]*[,]?[^,]?[0-9])+$"),
            this.getFootFallCoOrdinates
          ]
        ]
      };
      kgs.push(kg);
    });
    let kgG = kgs.map(k => this.fb.group(k));
    let kgA = this.fb.array(kgG);
    this.zoneMapForm.setControl("kpiGroups", kgA);
  }

  getValue(v) {
    if (v) {
      return v;
    }

    return "NA";
  }

  autoCompletedSelected(device: Device) {

    if (device && device._id) {
      this.selectedDeviceId = device._id;
    }

    this.kpiGroups = device.kpiGroups;
    this.setKpiGroups();

  }

  getKpiGroups() {
    return <FormArray>this.zoneMapForm.get("kpiGroups");
  }

  onSubmit(form: any) {
    if (!this.zoneMapForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    let body: any = {};
    // //Create zone mapping
    // this.deviceList.forEach((v, i) => {
    //   if (v.deviceName == form.deviceId) {
    //     form.deviceId = v._id;
    //   }
    // });
    body.deviceId = this.selectedDeviceId;//form.deviceId;
    body.kpi = [];
    form.kpiGroups.forEach(k => {
      if (k.selected) {
        body.kpi.push({
          kpiGroupId: k.kpiGroupId,
          kpiFactorBy: k.kpiFactorBy,
          operation: k.operation,
          elements:
            k.kpiGroupId == this.footFallKpiGroupId
              ? k.elementAdult + "|" + k.elementChild + "|" + k.elementStaff
              : k.elements
        });
      }
    });
    this.zoneService.createMap(form.zoneId, body).subscribe(
      res => {
        this.dialogRef.close();
        this.zoneService.sendAction("create", "");
        this.isSubmitted = 0;
      },
      err => {
        this.isSubmitted = 0;
      }
    );
  }

  delete(zoneId, mapped) {
    if (
      confirm("Are you sure you want to remove this mapped device.") == false
    ) {
      return false;
    }

    this.data.mapped = this.data.mapped.filter(
      m => m.deviceId !== mapped.deviceId
    );

    this.zoneService.deleteMapping(zoneId, mapped).subscribe(
      r => {
        this.zoneService.sendAction("update", "");
      },
      e => { }
    );
  }

  getFootFallCoOrdinates(
    control: AbstractControl
  ): { [key: string]: any } | null {
    var InputFootFall = [];
    var parent = control.parent;
    if (control.parent) {
      InputFootFall.push(...parent.controls["elementAdult"].value.split(","));
      InputFootFall.push(...parent.controls["elementChild"].value.split(","));
      InputFootFall.push(...parent.controls["elementStaff"].value.split(","));
      InputFootFall = InputFootFall.filter(function (entry) {
        return /\S/.test(entry);
      });
      for (var i = 0; i <= InputFootFall.length; i++) {
        for (var j = i; j <= InputFootFall.length; j++) {
          if (i != j && InputFootFall[i] == InputFootFall[j]) {
            return { SimilarValueError: true };
          }
        }
      }
    }
    return null;
  }

  resetElement(index): void {
    // (<FormArray>this.zoneMapForm.get('kpiGroups')).at(0).get('elementAdult')
    (<FormArray>this.zoneMapForm.get('kpiGroups')).at(index).patchValue({
      elementAdult: '',
      elementChild: '',
      elementStaff: '',
      elements: ''
    });

  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/zones/zones.component.ts